// extracted by mini-css-extract-plugin
module.exports = {"blog__hero":"BlogHero_blog__hero__k5IJR"};